// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import logo from 'assets/images/brand/smart-typing-logo.png';

// ==============================|| LOGO ||============================== //

const Logo = () => {
    const theme = useTheme();
    const textColor = theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.grey[900];

    return (
        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
            <Box component="img" src={logo} alt="SmartTyping" width={36} height={36} sx={{ display: 'block', borderRadius: '50%', flexShrink: 0 }} />
            <Box sx={{ lineHeight: 1 }}>
                <Typography component="span" sx={{ display: 'block', fontWeight: 800, fontSize: '1.05rem', lineHeight: 1.15, color: textColor, whiteSpace: 'nowrap' }}>
                    SmartTyping
                </Typography>
                <Typography component="span" sx={{ display: 'block', fontWeight: 600, fontSize: '0.68rem', letterSpacing: '0.08em', color: '#7c3aed', textTransform: 'uppercase' }}>
                    Backoffice
                </Typography>
            </Box>
        </Box>
    );
};

export default Logo;
